import React from "react";
import "./PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <>
      <section className="about-section pb-5">
        <div className="about-title">
          <h4 data-aos="fade-down" data-aos-duration="2000">
            Privacy Policy
          </h4>
        </div>

        <div className="container">
          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services pt-5">
              <h5># Disclaimer: </h5>
              <div
                className="forex-key-features"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <p>
                  The cryptocurrency market is deeply speculative, with various
                  risks including sudden market fluctuations, potential
                  manipulation, and technical issues. World Liberty Financial
                  Ltd. offers a free online trading platform for cryptocurrency
                  enthusiasts but does not take responsibility for the
                  investment value of cryptocurrencies, nor does it guarantee
                  any returns.
                </p>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>
                World Liberty Financial Ltd. and its users agree to the
                following terms:
              </h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    <p>
                      Before engaging in trading, users must thoroughly
                      understand the nature of the market and assess their own
                      level of risk tolerance and financial resources.
                    </p>
                  </li>
                  <li>
                    <p>
                      Digital asset transactions carry significant risk and
                      users should be prepared to potentially lose their entire
                      investment.
                    </p>
                  </li>
                  <li>
                    <p>
                      World Liberty Financial Ltd. does not guarantee the
                      accuracy or applicability of any market analysis and
                      cannot be held responsible for any information obtained
                      from third parties. Users accept all risks associated with
                      their transactions.
                    </p>
                  </li>
                  <li>
                    <p>
                      World Liberty Financial Ltd. may provide user data or take
                      measures in response to legal requirements, and is not
                      responsible for any resulting privacy disclosures or
                      operational issues.
                    </p>
                  </li>
                  <li>
                    <p>
                      Users are responsible for any financial losses resulting
                      from the suspension or prohibition of digital asset
                      transactions due to changes in laws or regulations.
                    </p>
                  </li>
                  <li>
                    <p>
                      World Liberty Financial Ltd. retains the ultimate
                      interpretation rights of the "World Liberty Financial Ltd.
                      Service Agreement".
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services pt-5">
              <h5># Privacy Policy: </h5>
              <div className="benefits-content-area">
                <ul>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    Privacy is of utmost importance at World Liberty Financial
                    Ltd.. We recognize the significance of protecting
                    information that is stored on our servers or network or is
                    intended to be stored on our servers or network and that
                    relates to an individual. The data we protect are the
                    “Personal Data” which is any information that can be used to
                    identify you directly or indirectly.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    This Privacy Policy is designed to address the regulatory
                    requirements of the jurisdictions in which Bitcoin.com
                    offers its Services, including the General Data Protection
                    Regulation (“GDPR”), as enacted by the European Commission,
                    and the California Consumer Privacy Act (“CCPA”). In this
                    Privacy Policy, the terms “Service” and “Services” have the
                    same meaning as described in the User Agreement.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    This Privacy Notice applies to all processing of Personal
                    Data on the website of the World Liberty Financial Ltd.and
                    all other World Liberty Financial Ltd. sites on which it
                    appears (the “Sites”). If you do not agree with this Privacy
                    Policy, in general, or any part of it, you should not use
                    the Sites or Services. This Privacy Policy is periodically
                    reviewed to ensure that any new obligations and changes to
                    our business model are taken into consideration. We may
                    amend this Privacy Policy at any time by posting an amended
                    version on our website.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    In this privacy policy, we will tell you: Who we are? What
                    Personal Data do we collect from you and how do we collect
                    it; On what legal basis do we collect your Personal Data;
                    For what purpose do we collect your Personal Data; How long
                    we store it for; Who do we share your Personal Data with;
                    Whether we intend to transfer it to another country; What
                    are your rights concerning your Personal Data; and
                    Children’s Privacy; and Changes to this Privacy Policy.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    Who are we and how can you contact us if you have any
                    concerns?
                    <p>
                      The organization that is responsible for ensuring that
                      your Personal Data is processed in compliance with
                      applicable regulations is Saint Bitts LLC, Nelson Springs
                      Commercial Complex, Calhoun Estate, Nevis, company number
                      L17015 (the “Data Controller”).
                      <br />
                      <br />
                      If you have any concerns or questions or if you would like
                      to exercise any of your rights with respect to your
                      Personal Data, you may contact our Data Protection Officer
                      (“DPO”) at World Liberty Financial Ltd..
                    </p>
                  </li>

                  <li>
                    What data do we collect about you and how do we collect it?
                    <p>
                      We collect your Personal Data through a variety of
                      methods: either you provide it to us directly, we collect
                      it from external sources, or we collect it by using
                      automated means. Information you may provide us: You may
                      give us information about you by filling in forms on our
                      Sites or through our app or by corresponding with us by
                      phone, email, or otherwise. This includes but is not
                      limited to the following information: Account
                      Administration. We may collect personal information from
                      you in connection with the administration of your account.
                      This personal information may include but is not limited
                      to, your name, date of birth, age, nationality, country of
                      residence, gender, occupation, signature, utility bills,
                      professional details, photographs, video footage, phone
                      number, home address, email address, government-issued
                      identification such as passport, driver’s license,
                      national identification card with photograph, tax
                      identification number, national insurance number, social
                      security number, visa information and/or any other
                      information deemed necessary to comply with our legal
                      obligations.
                      <br />
                      <br />
                      Financial and Transactional Information. We may collect
                      financial information such as your wallet address, bank
                      account numbers, bank statements, transaction history,
                      trading data, and credit/debit card numbers. We may
                      collect personal information and details associated with
                      your transactions including, but not limited to,
                      information about the transactions you make using our
                      services, the purpose of the transactions, information on
                      sources of your funds, sender and receiver of funds, and
                      ultimate beneficiary information.
                      <br />
                      <br />
                      Your Communications with Us. We may collect personal
                      information, such as email address, phone number, or
                      mailing address when you request information about our
                      Services, register for our newsletter, request customer or
                      technical support, or otherwise communicate with us.
                      <br />
                      <br />
                      Surveys. We may contact you to participate in surveys. If
                      you decide to participate, we may collect personal
                      information from you in connection with the survey.
                      <br />
                      <br />
                      Interactive Features. We and others who use our services
                      may collect personal information that you submit or make
                      available through our interactive features (e.g.,
                      messaging and chat features, commenting functionalities,
                      forums, blogs, and social media pages). Any information
                      you provide using the public sharing features of the
                      Services will be considered “public,” unless otherwise
                      required by applicable law, and is not subject to the
                      privacy protections referenced herein.
                      <br />
                      <br />
                      Sweepstakes or Contests. We may collect personal
                      information you provide for any sweepstakes or contests
                      that we offer. In some jurisdictions, we are required to
                      publicly share information about sweepstakes and contest
                      winners.
                      <br />
                      <br />
                      Conferences, Trade Shows, and Other Events. We may collect
                      personal information from you when we attend or host
                      conferences, trade shows, and other events.
                      <br />
                      <br />
                      Business Development and Strategic Partnerships. We may
                      collect personal information from you and third parties to
                      assess and pursue potential business opportunities.
                      <br />
                      <br />
                      Job Applications. We may post job openings and
                      opportunities on our Services. If you respond to one of
                      these postings, we may collect your personal information,
                      such as your application, CV, cover letter, and/or any
                      other information you provide to us.
                      <br />
                      <br />
                      Information Collected Automatically: About each of your
                      visits to our Sites or our app we automatically collect
                      the following information:
                      <br />
                      <br />
                      Automatic Collection of Personal Information. We may
                      collect certain information automatically when you use our
                      Services, such as your Internet protocol (IP) address,
                      user settings, MAC address, cookie identifiers, mobile
                      carrier, mobile advertising, and other unique identifiers,
                      browser or device information, location information
                      (including precise location information and/or approximate
                      location derived from IP address), and Internet service
                      provider. We may also automatically collect information
                      regarding your use of our Services, such as pages that you
                      visit before, during, and after using our Services,
                      information about the links you click, the types of
                      content you interact with, the frequency and duration of
                      your activities, and other Information about how you use
                      our Services.
                      <br />
                      <br />
                      Device Information: We collect information about the
                      device you use to access your account, including the
                      hardware model, operating system version, and unique
                      device identifiers, but this information is anonymized and
                      not tied to any particular person.
                      <br />
                      <br />
                      Transaction Information: In connection with our Services
                      (as such term is defined in our User Agreement), we may
                      collect and maintain information relating to transactions
                      you effect using the World Liberty Financial Ltd. Wallet
                      (e.g. converting one virtual currency to another or
                      purchasing virtual currencies).
                      <br />
                      <br />
                      Information We Collect Required By Law, Rule, or
                      Regulation: Depending on the Service, we may collect
                      information from you in order to meet regulatory
                      obligations around know-your-customer (“KYC”) and
                      anti-money laundering (“AML”) requirements. Information
                      that we collect from you includes the following:
                      <br />
                      <br />
                      Full name Residential address Contact details (telephone
                      number, email address) Date and place of birth, gender,
                      place of citizenship Bank account information and/or
                      credit card details Your status as a politically exposed
                      person Source of funds & proof of address Passport and/or
                      national driver’s license or government-issued
                      identification card to verify your identity.
                      <br />
                      <br />
                      Transaction history and account balances in connection
                      with your use of certain Services. Information We Collect
                      from External Sources: We also receive information from
                      other sources and combine that with the information we
                      collect through our Services. For instance:
                      <br />
                      <br />
                      We use "cookies" from time to time to help personalize
                      your online experience with us. A cookie is a small text
                      file that is stored on your computer to help us make your
                      visit to our Sites more “user-friendly.” Please see our
                      Cookie Policy for more details about the cookies we use.
                      Cookies provide us with information about your use of the
                      Sites that can help us improve the Sites and your
                      experience with them. We will process Personal Data
                      collected through cookies under this Privacy Policy. If
                      you have set your browser to alert you before accepting
                      cookies, you should receive an alert message with each
                      cookie. You may refuse cookies by turning them off in your
                      browser, however, you should be aware that our Sites, like
                      most other popular sites, may not work well with cookies
                      disabled.
                      <br />
                      <br />
                      We may analyze public blockchain data to ensure parties
                      utilizing our Services are not engaged in illegal or
                      prohibited activity under our User Agreement and to
                      analyze transaction trends for research and development
                      purposes.
                      <br />
                      <br />
                      We use third-party services that may be co-branded as
                      World Liberty Financial Ltd. but will do so with clear
                      notice. Any third-party services may collect information
                      as determined by their own privacy policies.
                      <br />
                      <br />
                      Banks or payment processors that you use to transfer fiat
                      currency may provide us with basic Personal Data, such as
                      your name and address, as well as, your bank account
                      information.
                      <br />
                      <br />
                      Advertising or analytics providers may provide us with
                      anonymized information about you, including but not
                      limited to, how you found our website.
                    </p>
                  </li>

                  <li>
                    On what basis do we collect your data?
                    <p>
                      We only use your Personal Data where we have a legal basis
                      to do so: Consent. For some processing activities, we
                      require your prior consent. This applies for example to
                      some of our direct marketing activities which fall under
                      the scope of the GDPR. You will always be prompted to take
                      clear, affirmative action so that we can ensure that you
                      agree with the processing of your Personal Data. This
                      action may, for example, take the form of a checkbox. If
                      you have given us your consent for processing operations,
                      you may always change your mind, and withdraw your consent
                      at any time and easily; all you need to do is send us an
                      email at the following address World Liberty Financial
                      Ltd.
                      <br />
                      <br />
                      Performance of a contract. Some Personal Data we process
                      about you is for the performance of a contract to which
                      you are a party or in order to take steps at your request
                      prior to entering into a contract with us.
                      <br />
                      <br />
                      Legal obligation. In some cases, we have to process your
                      Personal Data to comply with legal obligations, including
                      those applicable to financial services institutions, such
                      as under the Bank Secrecy Act and other anti-money
                      laundering laws. You may not be eligible for certain
                      Services if we cannot collect the Personal Data necessary
                      to meet our legal obligations.
                      <br />
                      <br />
                      Legitimate interest. In most cases where we process
                      Personal Data in the context of our Services we rely on
                      our legitimate interests in conducting our normal business
                      as a legal basis for such processing. Our legitimate
                      interests are to identify or prevent fraud, to enhance the
                      security of our network and information systems, or to
                      carry out processing operations for statistical purposes.
                      We will use legitimate interest only when we have carried
                      out an assessment on the impact that this processing may
                      have on you, and concluded that the processing does not
                      unduly infringe your rights and freedoms. For example, we
                      do not use this justification if we process sensitive
                      data, or when the processing would be unexpected for you,
                      or if we consider it to be too intrusive.
                      <br />
                      <br />
                      Legitimate interest. In most cases where we process
                      Personal Data in the context of our Services we rely on
                      our legitimate interests in conducting our normal business
                      as a legal basis for such processing. Our legitimate
                      interests are to identify or prevent fraud, to enhance the
                      security of our network and information systems, or to
                      carry out processing operations for statistical purposes.
                      We will use legitimate interest only when we have carried
                      out an assessment on the impact that this processing may
                      have on you, and concluded that the processing does not
                      unduly infringe your rights and freedoms. For example, we
                      do not use this justification if we process sensitive
                      data, or when the processing would be unexpected for you,
                      or if we consider it to be too intrusive.
                    </p>
                  </li>

                  <li>
                    For what purposes do we collect your data?
                    <p>
                      We collect your Personal Data to: Provide our Services
                      (including customer support); Process transactions and
                      send notices about your transactions; Resolve disputes,
                      collect fees, and troubleshoot problems; Communicate with
                      you about our Services and business and inform you of
                      matters that are important for your account and/or use of
                      the Sites. We also use your Personal Data to respond to
                      any questions, comments, or requests you filed with us and
                      the handling of any complaints; Comply with applicable
                      laws and regulations; Establish, exercise, and defend
                      legal claims; Monitor and report compliance issues;
                      <br />
                      <br />
                      Customize, measure, and improve our business, the
                      Services, and the content and layout of our Sites and apps
                      (including developing new products and services; managing
                      our communications; determining the effectiveness of our
                      sales, marketing, and advertising; analyzing and enhancing
                      our products, services, websites, and apps; ensuring the
                      security of our networks and information systems;
                      performing accounting, auditing, invoicing,
                      reconciliation, and collection activities; and improving
                      and maintaining the quality of our customer services);
                      <br />
                      <br />
                      Deliver targeted marketing, service update notices, and
                      promotional offers based on your communication
                      preferences, and measure the effectiveness of it. To
                      approach you via email for marketing purposes, we request
                      your consent, unless it is not required by law. You always
                      have the option to unsubscribe from our mailings, e.g.,
                      via the unsubscribe link in our newsletter;
                      <br />
                      <br />
                      Perform risk management, including comparing information
                      for accuracy and verifying it with third parties and
                      protecting against, identifying, and preventing fraud and
                      other prohibited or illegal activity, claims, and other
                      liabilities; and Enforce our contractual terms.
                    </p>
                  </li>

                  <li>
                    How long do we keep your data?
                    <p>
                      We will only retain your personal information for as long
                      as necessary to fulfill the purposes for which we
                      collected it, including to satisfy any legal, accounting,
                      or reporting obligations or resolve disputes. While
                      retention requirements vary by jurisdiction, information
                      about our typical retention periods for different aspects
                      of your personal information is described below.
                      <br />
                      <br />
                      Contact Information such as your name, email address, and
                      telephone number for marketing purposes is retained on an
                      ongoing basis until you unsubscribe. Thereafter we will
                      add your details to our suppression list to ensure we do
                      not inadvertently market to you.
                      <br />
                      <br />
                      Personal information collected to comply with our legal
                      obligations under financial or anti-money laundering laws
                      may be retained after account closure for as long as
                      required under such laws.
                      <br />
                      <br />
                      Content that you post on our Sites such as support desk
                      comments, photographs, videos, blog posts, and other
                      content may be kept after you close your account for audit
                      and crime prevention purposes (e.g. to prevent a known
                      fraudulent actor from opening a new account).
                      <br />
                      <br />
                      Information collected via technical means such as cookies,
                      web page counters, and other analytics tools is kept for a
                      period of up to one year from the expiry of the cookie.
                      <br />
                      <br />
                      When Personal Data is no longer necessary for the purpose
                      for which it was collected, we will remove any details
                      that identify you or we will securely destroy the records,
                      where permissible. However, we may need to maintain
                      records for a significant period of time (after you cease
                      using a particular Service) as mandated by regulation. For
                      example, we are subject to certain anti-money laundering
                      laws that require us to retain the following, for a period
                      of five (5) years after our business relationship with you
                      has ended.
                    </p>
                  </li>

                  <li>
                    Who do we share your Personal Data with?
                    <p>
                      We may share your information with selected recipients to
                      perform functions required to provide certain Services to
                      you and/or in connection with our efforts to prevent and
                      investigate fraudulent or other criminal activity. All
                      such third parties will be contractually bound to protect
                      data in compliance with our Privacy Policy. The categories
                      of recipients include:
                      <br />
                      <br />
                      Other World Liberty Financial Ltd. entities, including to
                      help detect and prevent potentially illegal acts and
                      violations of our policies, and to guide decisions about
                      our products, services, and communications;
                      <br />
                      <br />
                      Service providers who help with our business operations
                      and deliver our Services, such as Cloud service providers
                      providing cloud infrastructure; Providers of ID
                      verification solutions and other due diligence solutions
                      (such as KYC and anti-money laundering); Providers of
                      website analytics; Providers of customer service
                      solutions; and Providers of marketing automation
                      platforms.
                      <br />
                      <br />
                      Law enforcement, government officials, regulatory
                      agencies, our banks, and other third parties under a
                      subpoena, court order, or other legal process or
                      requirement if applicable to Bitcoin.com; or when we
                      believe, in our sole discretion, that the disclosure of
                      data is necessary to report suspected illegal or
                      fraudulent activity or to investigate violations of our
                      User Agreement.
                      <br />
                      <br />
                      We also may share Personal Data with a buyer or other
                      successor in the event of a merger, divestiture,
                      restructuring, reorganization, dissolution, or other sale
                      or transfer of some or all of World Liberty Financial Ltd.
                      assets, whether as a going concern or as part of
                      bankruptcy, liquidation or similar proceeding, in which
                      Personal Data held by Bitcoin.com is among the assets
                      transferred.
                      <br />
                      <br />
                      Funding and transaction information related to your use of
                      certain Services may be recorded on a public blockchain.
                      Public blockchains are distributed ledgers, intended to
                      immutably record transactions across wide networks of
                      computer systems. Many blockchains are open to forensic
                      analysis which can lead to deanonymization and the
                      unintentional revelation of private financial information,
                      especially when blockchain data is combined with other
                      data.
                      <br />
                      <br />
                      Because blockchains are decentralized or third-party
                      networks that are not controlled or operated by World
                      Liberty Financial Ltd. or its affiliates, we are not able
                      to erase, modify, or alter Personal Data from such
                      networks.
                    </p>
                  </li>

                  <li>
                    Is your data transferred outside of the European Union?
                    <p>
                      As we are located outside of the European Union, we will
                      ensure that any entity, whether our processor or affiliate
                      that transfers Personal Data to us from the EU employs
                      appropriate safeguards. If your Personal Data is
                      transferred to us from the European Economic Area by our
                      service providers (i.e., Data Processors who are engaged
                      on our behalf) and business partners, we will ensure that
                      the transfer is lawful.
                    </p>
                  </li>

                  <li>
                    What are your rights?
                    <p>
                      Under the GDPR and relevant implementation acts,
                      individuals have statutory rights related to their
                      Personal Data. Please note that rights are not absolute
                      and may be subject to conditions.
                      <br />
                      <br />
                      One key right is the Right to object. You have the right
                      to object to the processing of your Personal Data where we
                      are relying on legitimate interests as our legal basis
                      (see above). Under certain circumstances, we may have
                      compelling legitimate grounds that allow us to continue
                      processing your Personal Data. Insofar as the processing
                      of your Personal Data takes place for direct marketing
                      purposes, including profiling for direct marketing, we
                      will always honor your request.
                      <br />
                      <br />
                      Other rights are as follows: Right to withdraw consent.
                      Insofar as our processing of your Personal Data is based
                      on your consent (see above), you have the right to
                      withdraw consent at any time. Right of access. You have
                      the right to request access to your Personal Data. Right
                      to rectification. You have the right to request
                      rectification of the Personal Data that we hold about you.
                      Right to erasure. You have the right to request erasure of
                      your Personal Data. This enables you to ask us to delete
                      or remove Personal Data in certain circumstances. Right to
                      restriction. You have the right to request restriction of
                      processing of your Personal Data. Right to data
                      portability. In some cases, you have the right to request
                      to transfer your Personal Data to you or to a third party
                      of your choice. The exercise of the aforementioned rights
                      is free of charge and can be carried out by accessing our
                      Data Subject Request Portal or contacting us at World
                      Liberty Financial Ltd.
                      <br />
                      <br />
                      Before responding to your request, we will verify your
                      identity and/or ask you to provide us with more
                      information to respond to your request, if we have any
                      doubts about your identity. We will do our best to respond
                      to your request within one month unless your request is
                      particularly complex (for example if your request concerns
                      a large amount of sensitive data). In such a case, we will
                      inform you of the need to extend this response time by two
                      additional months.
                    </p>
                  </li>

                  <li>
                    How about children’s privacy?
                    <p>
                      World Liberty Financial Ltd. does not address anyone under
                      the age of 18. We do not knowingly collect personally
                      identifiable information from anyone under the age of 18.
                      If you are a parent or guardian and you are aware that
                      your child has provided us with Personal Data, please
                      contact us at World Liberty Financial Ltd. If we become
                      aware that we have collected Personal Data from children
                      without verification of parental consent, we take steps to
                      remove that information from our servers.
                    </p>
                  </li>

                  <li>
                    What happens if we make changes to this Privacy Policy?
                    <p>
                      We may update this policy to reflect changes to our
                      information practices but we will not reduce your rights
                      under this Privacy Policy without your express consent. We
                      will post any changes to this page and, if the changes are
                      significant, we will provide a more prominent notice. We
                      will also keep prior versions of this Privacy Policy in an
                      archive for your review. We encourage you to periodically
                      review our Privacy Policy for the latest information on
                      our privacy practices and to contact us if you have any
                      questions or concerns.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="forex-key-features"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <h5># About Blockchain: </h5>
            <p>
              A blockchain is a sequence of blocks, each containing information,
              linked together nsuring safety as long as one server is
              operational. Nodes provide storage and computing power. Modifying
              blockchain information requires the approval of morin
              chronological order. This chain is stored on all servers (nodes)
              in the system, ee than half of the nodes and changes to all nodes,
              making tampering extremely difficult. Blockchain's two core
              features are data immutability and decentralization, making
              recorded information more authentic and reliable, which helps
              address mutual mistrust
            </p>
            <p>
              <span>Origin: </span>
              Blockchain originated from Bitcoin. On November 1, 2008, a person
              known as Satoshi Nakamoto published the article "Bitcoin: A
              Peer-to-Peer Electronic Cash System," outlining the electronic
              cash system's architecture based on P2P network technology,
              encryption technology, timestamp technology, and blockchain
              technology. This marked the birth of Bitcoin. Two months later,
              the theory was put into practice, and on January 3, 2009, the
              first genesis block (serial number 0) was created. A few days
              later, on January 9, 2009, a block with serial number 1 appeared,
              connecting with the genesis block to form a chain, marking the
              birth of the blockchain.
            </p>
            <p>
              <span>Concept Definition: </span>
              In a narrow sense, blockchain is a chained data structure that
              connects data blocks sequentially in chronological order, forming
              a tamper-proof and forgery-resistant distributed ledger ensured by
              cryptography. In a broader sense, blockchain technology uses this
              data structure to verify and store data, employs distributed node
              consensus algorithms to generate and update data, uses
              cryptography to secure data transmission and access, and utilizes
              smart contracts composed of automated script codes. This
              constitutes a new distributed infrastructure and computing
              paradigm for programming and managing data.
            </p>
            <p>
              <span>Development History: </span>
              In 2008, Satoshi Nakamoto first proposed the concept of
              blockchain, which later became the core component of the
              electronic currency Bitcoin, serving as a public ledger for all
              transactions. Utilizing a peer-to-peer network and distributed
              timestamp servers, blockchain databases can be managed
              autonomously. This innovation made Bitcoin the first digital
              currency to solve the double-spending problem, inspiring other
              applications.
              <br />
              <br />
              In 2014, "Blockchain 2.0" emerged as a term for a decentralized
              blockchain database. This second-generation programmable
              blockchain is seen by economists as a programming language that
              allows users to write sophisticated and intelligent agreements. It
              can enable income from dividends of completed freight orders or
              shared certificates, bypass transactions, and eliminate
              intermediaries. Blockchain 2.0 enhances privacy, empowers
              individuals to monetize their information, and secures returns for
              intellectual property owners. It also allows for storing an
              individual's "permanent digital ID and image" and addresses
              "potential social wealth distribution" inequality.
              <br />
              <br />
              On January 10, 2019, the State Internet Information Office issued
              the "Blockchain Information Service Management Regulations." On
              October 24, 2019, during the 18th collective study of the
              Political Bureau of the Central Committee, General Secretary Xi
              Jinping emphasized blockchain as an important breakthrough for
              independent innovation of core technologies and called for
              accelerating the development of blockchain technology and
              industrial innovation. As a result, "blockchain" has garnered
              significant public attention and become a societal focus.
            </p>
          </div>

          <div
            className="forex-key-features"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <h5>Types of Blockchain</h5>

            <p>
              <span># Public Blockchains: </span>
              Public blockchains allow any individual or group worldwide to send
              transactions, which can be effectively confirmed by the
              blockchain. Anyone can participate in the consensus process. These
              are the earliest and most widely used blockchains. Major virtual
              digital currencies, such as Bitcoin, are based on public
              blockchains, with only one blockchain corresponding to each
              currency globally.
            </p>
            <p>
              <span># Consortium Blockchains: </span>
              Consortium blockchains involve multiple pre-selected nodes
              designated by a group to act as bookkeepers. The generation of
              each block is jointly decided by these pre-selected nodes, which
              participate in the consensus process. Other access nodes can
              participate in transactions but do not engage in the bookkeeping
              process. This setup remains managed bookkeeping but becomes
              distributed, with the number of pre-selected nodes and the
              determination of each block's bookkeeper being the main risk
              points. Limited queries can be made by others through the
              blockchain's open API.
            </p>
            <p>
              <span> #Private Blockchains: </span>
              Private blockchains use general ledger technology solely for
              bookkeeping by a company or individual. The storage schemes are
              not much different from other uses. While traditional finance
              experiments with private blockchains, applications for public
              blockchains like Bitcoin have already been industrialized.
              Applications for private blockchains are still being explored.
            </p>
          </div>

          <div
            className="forex-key-features"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <h5>Key Features of Blockchain</h5>

            <p>
              <span>#Decentralization: </span>
              Blockchain technology operates without the need for third-party
              management agencies or hardware facilities and lacks central
              control. Through distributed accounting and storage, each node
              handles self-verification, information transmission, and
              management independently. Decentralization is the most prominent
              and essential feature of blockchain.
            </p>

            <p>
              <span>#Openness: </span>
              Blockchain technology is built on open-source principles. Apart
              from the encrypted private information of transaction parties,
              blockchain data is accessible to everyone. Anyone can query
              blockchain data and develop related applications through public
              interfaces, ensuring high transparency of the entire system's
              information.
            </p>

            <p>
              <span>#Independence: </span>
              The blockchain system operates independently based on
              consensus-based specifications and protocols, such as Bitcoin's
              hash algorithm. It does not rely on third parties, allowing all
              nodes to automatically and securely verify and exchange data
              within the system without human intervention.
            </p>

            <p>
              <span> #Security: </span>
              Blockchain's security is robust as long as no single entity
              controls 51% of all data nodes, preventing arbitrary manipulation
              and modification of network data. This safeguard makes the
              blockchain inherently secure and protects against subjective and
              artificial data changes.
            </p>

            <p>
              <span> #Anonymity: </span>
              Technically, the identity information of each block node does not
              need to be disclosed or verified, allowing information
              transmission to remain anonymous, except when legal requirements
              mandate disclosure.
            </p>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>### Components of a Blockchain System</h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span> **Data Layer**</span>
                <ol>
                  <li>
                    - **Components**:
                    <p>Underlying data blocks, data encryption, timestamps</p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      Encapsulates basic data and algorithms, ensuring secure
                      and time-verified information.
                    </p>
                  </li>
                </ol>
              </div>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span> **Network Layer** </span>
                <ol>
                  <li>
                    - **Components**:
                    <p>
                      {" "}
                      Distributed networking mechanisms, data dissemination
                      mechanisms, data verification mechanisms
                    </p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      {" "}
                      Manages how data is shared and verified across the
                      network.
                    </p>
                  </li>
                </ol>
              </div>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span>**Consensus Layer**</span>
                <ol>
                  <li>
                    - **Components**:
                    <p>Various consensus algorithms</p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      Facilitates agreement among network nodes on the state of
                      the blockchain.
                    </p>
                  </li>
                </ol>
              </div>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span> **Incentive Layer**</span>
                <ol>
                  <li>
                    - **Components**:
                    <p>
                      Economic incentives issuance and distribution mechanisms{" "}
                    </p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      {" "}
                      Integrates economic factors to motivate participation and
                      maintain the blockchain system.{" "}
                    </p>
                  </li>
                </ol>
              </div>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span>**Contract Layer**</span>
                <ol>
                  <li>
                    - **Components**:
                    <p> Scripts, algorithms, smart contracts </p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      Provides the foundation for programmable features,
                      enabling automated and flexible transactions.{" "}
                    </p>
                  </li>
                </ol>
              </div>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <span> **Application Layer**</span>
                <ol>
                  <li>
                    - **Components**:
                    <p> Various application scenarios and cases </p>
                  </li>
                  <li>
                    - **Functions**:
                    <p>
                      {" "}
                      Encapsulates specific uses of blockchain technology across
                      different sectors.{" "}
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="forex-key-features"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <h5>### Representative Innovations in Blockchain Technology</h5>

            <p>
              <span> - **Chained Block Structure with Timestamps**:</span>
              Ensures data integrity and chronological order.
            </p>
            <p>
              <span>- **Consensus Mechanism of Distributed Nodes**: </span>
              Secures agreement on blockchain updates without central authority.
            </p>
            <p>
              <span>
                - **Economic Incentives Based on Consensus Computing Power**:{" "}
              </span>
              Encourages active participation and network security.
            </p>
            <p>
              <span>- **Flexible and Programmable Smart Contracts**: </span>
              Allows for automated, condition-based transactions and operations.
            </p>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>Seven Core Technologies of Blockchain</h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    Distributed Ledger
                    <p>
                      <span>- **Definition**:</span> Transaction bookkeeping is
                      completed by multiple nodes distributed in different
                      locations, with each node recording a complete account.{" "}
                      <br /> <span>- **Key Features**: -</span> Each node stores
                      complete data according to the blockchain structure,
                      unlike traditional distributed storage which divides data
                      into parts. <br />
                      - Nodes are independent and equal, ensuring data
                      consistency through a consensus mechanism without a
                      central authority.
                      <br />- Prevents single-node control, ensuring security
                      and reliability of the account data.
                    </p>
                  </li>
                  <li>
                    Asymmetric Encryption
                    <p>
                      <span>- **Definition**: </span>
                      Ensures that transaction information is public while
                      account identity information is highly encrypted.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Data security and personal privacy are maintained.
                      <br />- Only the data owner can authorize access to
                      account identity information.
                    </p>
                  </li>
                  <li>
                    Consensus Mechanism
                    <p>
                      <span>- **Definition**: </span>
                      The method by which all accounting nodes reach a consensus
                      on the validity of a record.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Prevents tampering and ensures record validity.
                      <br />
                      - Different mechanisms for different scenarios, balancing
                      efficiency and security.
                      <br />
                      - "Minority obeys the majority" principle, where
                      "majority" can mean computing power, shares, etc.
                      <br />
                      - Nodes have equal rights to propose consensus results,
                      recognized by others and forming the final consensus.
                      <br />
                    </p>
                  </li>
                  <li>
                    Smart Contracts
                    <p>
                      <span>- **Definition**: </span>
                      Automated execution of predefined rules and terms based on
                      credible and immutable data.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Examples include automating claims settlement in
                      insurance. <br />
                      - Improves risk management capabilities for businesses,
                      such as insurance companies. <br />
                      - Facilitates policyholder risk management and company
                      risk supervision. <br />
                    </p>
                  </li>
                  <li>
                    Chained Block Structure
                    <p>
                      <span>- **Definition**: </span>
                      Data is stored in blocks that are chained together in
                      chronological order.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Ensures data integrity and security through a sequence
                      of blocks. <br />- Each block contains a timestamp,
                      securing the timeline of data.
                    </p>
                  </li>
                  <li>
                    Peer-to-Peer Network
                    <p>
                      <span>- **Definition**: </span>
                      A network architecture where each node can communicate
                      directly with others.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Eliminates the need for a central server. <br />-
                      Enhances resilience and fault tolerance.
                    </p>
                  </li>
                  <li>
                    Economic Incentives
                    <p>
                      <span>- **Definition**: </span>
                      Integration of economic factors into the blockchain to
                      motivate participation.
                      <br />
                      <span>- **Key Features**:</span>
                      <br />
                      - Includes issuance and distribution mechanisms for
                      rewards. <br />- Encourages nodes to contribute to the
                      network’s security and efficiency.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>Eight Applications of Blockchain Technology</h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    Financial Sector
                    <p>
                      Blockchain has immense potential in financial areas like
                      international exchange, letters of credit, equity
                      registration, and stock exchanges. It can eliminate
                      third-party intermediaries, enabling direct peer-to-peer
                      transactions, reducing costs, and speeding up payments.
                      <br />
                      <span>- **Example**: </span>
                      Visa's B2B Connect for cross-border payments, Citibank's
                      Citicoin, and China's digital renminbi payment service in
                      Xiong'an New District.
                    </p>
                  </li>
                  <li>
                    Internet of Things (IoT) and Logistics
                    <p>
                      Blockchain can enhance IoT and logistics by reducing
                      costs, tracing item production and delivery, and improving
                      supply chain management efficiency.
                      <br />
                      <span>- **Example**: </span>
                      Blockchain combined with big data solutions can secure
                      transactions and improve the efficiency of IoT
                      transactions and intelligent logistics.
                    </p>
                  </li>

                  <li>
                    Public Service
                    <p>
                      Blockchain can transform public management, energy, and
                      transportation by providing decentralized DNS services,
                      ensuring system and firmware integrity, and securing IoT
                      data transmission.
                      <br />
                      <span>- **Example**: </span>
                      Using blockchain to monitor the status and integrity of
                      important infrastructure software and firmware.
                    </p>
                  </li>

                  <li>
                    Digital Rights
                    <p>
                      Blockchain can authenticate and prove the existence of
                      works like text, video, and audio, ensuring ownership
                      authenticity and uniqueness. It supports real-time
                      transaction recording and full lifecycle management of
                      digital copyrights.
                      <br />
                      <span>- **Example**: </span>
                      Mediachain by Mine Labs for digital image copyright
                      protection using IPFS file system.
                    </p>
                  </li>

                  <li>
                    Insurance
                    <p>
                      Smart contracts can automate insurance claims, reducing
                      management and operational costs for insurance companies.
                      <br />
                      <span>- **Example**: </span>
                      LenderBot, launched by Stratumn, Deloitte, and Lemonway,
                      allows registration for micro-insurance products via
                      Facebook Messenger.
                    </p>
                  </li>

                  <li>
                    Public Welfare
                    <p>
                      Blockchain's reliable and tamper-proof data storage is
                      suitable for public welfare scenarios, enhancing
                      transparency and social supervision.
                      <br />
                      <span>- **Example**: </span>
                      Storing donation project details, fundraising, and
                      recipient feedback on the blockchain.
                    </p>
                  </li>

                  <li>
                    Healthcare
                    <p>
                      Blockchain can secure and streamline the management of
                      medical records, ensuring data integrity and patient
                      privacy.
                      <br />
                      <span>- **Example**: </span>
                      Patients can grant access to their medical data securely,
                      enabling better healthcare coordination and research.
                    </p>
                  </li>

                  <li>
                    Supply Chain Management
                    <p>
                      Blockchain can enhance supply chain transparency,
                      traceability, and efficiency by recording every step of
                      the product journey from origin to consumer.
                      <br />
                      <span>- **Example**: </span>
                      Using blockchain to track the journey of food products,
                      ensuring quality and authenticity.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>Nice Problems Faced in Blockchain Technology</h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    **Conceptual, Systemic, and Legal Restrictions**:
                    <p>
                      <span>- **Current Restrictions**: </span>
                      Blockchain's decentralized nature and self-management
                      challenge traditional systems and legal frameworks,
                      creating friction.
                      <br />
                      <span> - **Global Perspectives**: </span>
                      Countries have different attitudes towards blockchain
                      applications, leading to regulatory uncertainty and
                      hindering its adoption.
                    </p>
                  </li>

                  <li>
                    **Technical Challenges**:
                    <p>
                      <span> - **Initial Stage**: </span>
                      Blockchain is in its early development stages, lacking
                      mature, intuitive products similar to Internet
                      technologies.
                      <br />
                      <span>- **Block Capacity**: </span>
                      The growing data size in each block presents storage,
                      verification, and capacity challenges that need to be
                      addressed.
                    </p>
                  </li>

                  <li>
                    **Competitive Technological Challenges**:
                    <p>
                      <span>- **Competing Technologies**: </span>
                      Other technologies, such as quantum communication, offer
                      similar security and efficiency benefits, posing
                      competition to blockchain.
                    </p>
                  </li>

                  <li>
                    **Scalability**:
                    <p>
                      <span> - **Transaction Speed**: </span>
                      Blockchain currently struggles with processing a high
                      volume of transactions quickly, impacting its scalability
                      for large-scale applications.
                    </p>
                  </li>

                  <li>
                    **Energy Consumption**:
                    <p>
                      <span>- **Proof of Work (PoW)**: </span>
                      The consensus mechanism used by many blockchains, like
                      Bitcoin, consumes significant energy, raising
                      environmental concerns.
                    </p>
                  </li>

                  <li>
                    **Interoperability**:
                    <p>
                      <span>- **Cross-Chain Communication**: </span>
                      Different blockchain networks often cannot communicate or
                      share data, limiting their functionality and integration
                      potential.
                    </p>
                  </li>

                  <li>
                    **Security and Privacy**:
                    <p>
                      <span> - **51% Attack**: </span>
                      If a single entity controls more than half of the
                      network’s computational power, it can manipulate the
                      blockchain, threatening security.
                      <br />
                      <span> - **Privacy Concerns**: </span>
                      Despite being anonymous, blockchain transactions are
                      transparent, leading to potential privacy issues for
                      users.
                    </p>
                  </li>

                  <li>
                    **Regulation and Compliance**:
                    <p>
                      <span> - **Regulatory Uncertainty**: </span>
                      The lack of clear regulations across jurisdictions creates
                      challenges for blockchain adoption, especially in
                      financial and legal sectors.
                    </p>
                  </li>

                  <li>
                    **User Adoption and Understanding**:
                    <p>
                      <span> - **Complexity**: </span>
                      The technical complexity and newness of blockchain
                      technology can deter user adoption and understanding,
                      requiring substantial educational efforts.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
